import React from 'react';

import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { Button,Modal, notification } from 'antd';

import { WORK_JOURNEY_STATUS } from '@src/packages/workJourney/constants';
import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';
import { useWorkJourneyValidationTranslations } from '@src/packages/workJourney/hooks/useWorkJourneyValidationTranslations';
import { notifyWorkJourneySaveError } from '@src/packages/workJourney/utils/submitWorkJourneyForm';
import WorkJourneyService from '@src/services/WorkJourneyService';
import safeExecute from '@src/util/safeExecute';

import styles from './WorkJourneyEditConfirm.module.less';

const workJourneyService = new WorkJourneyService();

const WorkJourneyActivateConfirm = () => {
  const { 
    workJourneyForm, 
    setIsSaving, 
    isSaving,
    orgId,
    modalVisibility,
    toggleModalVisibility,
  } = useWorkJourneyContext();

  const history = useHistory();
  const intl = useIntl();
  const validationTranslations = useWorkJourneyValidationTranslations();

  const handleCancel = () => {
    toggleModalVisibility('activateModal');
  };

  const activateJourney = async () => {
    if (isSaving) return;

    setIsSaving(true);
    safeExecute(async () => {
      const data = {
        ...workJourneyForm,
        state: WORK_JOURNEY_STATUS.ACTIVE,
      };

      const res = await workJourneyService
        .update(data, orgId, validationTranslations)
        .catch((error: unknown) => {
          notifyWorkJourneySaveError(error, intl, {
            members: data.members,
            matchUrl: `/${orgId}/-`,
          });
          return undefined;
        })
        .finally(() => {
          setIsSaving(false);
          toggleModalVisibility('activateModal');
        });

      if (res) {
        const message = intl.formatMessage({ id: 'workJourney.successActivate' });
        notification.success({ message });
        setTimeout(() => history.push(`/${orgId}/-/work-journey`), 500);
      }
    });
  };

  return (
    <Modal
      className={styles.modal}
      open={modalVisibility.activateModal}
      onCancel={handleCancel}
      closable={false}
      title={null}
      width={520}
      footer={[
        <Button key="cancel" onClick={handleCancel} disabled={isSaving}>
          {intl.formatMessage({ id: 'button.cancel' })}
        </Button>,
        <Button 
          key="activate"
          type="primary"
          disabled={isSaving}
          onClick={activateJourney} 
          loading={isSaving}
        >
          {intl.formatMessage({ id: 'workJourney.activate.button' })}
        </Button>
      ]}
    >
      <div className={styles.iconContainer}>
        <span className={`material-icons-outlined ${styles.icon}`}>info</span>
      </div>
      
      <div className={styles.title}>
        {intl.formatMessage({ id: 'workJourney.activate.title' })}
      </div>

      <div className={styles.description}>
        {intl.formatMessage({ id: 'workJourney.activate.description' })}
      </div>
    </Modal>
  );
};

export default WorkJourneyActivateConfirm;
